interface BookmarkIconProps {
  className?: string;
  filled?: boolean;
}

export const BookmarkIcon = ({ className = 'h-5 w-5', filled = false }: BookmarkIconProps) => (
  <svg
    className={className}
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth={filled ? 0 : 2}
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 5v16l7-5 7 5V5a2 2 0 00-2-2H7a2 2 0 00-2 2z"
    />
  </svg>
);
